const lightbox = require('lightbox2/dist/js/lightbox.min.js');

const portfolio = () => {
    lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true
    })
}

export default portfolio